import { Box, Typography } from '@mui/material';
import { FC, PropsWithChildren } from 'react';
import { useStyles } from '../../theme/styles.helpers';
import { ListCardStyles } from './ListCard.Styles';

interface ListCardProps {
  title: string;
  count: number;
}

export const ListCard: FC<PropsWithChildren<ListCardProps>> = ({
  title,
  count,
  children,
}) => {
  const styles = useStyles(ListCardStyles, {});

  return (
    <Box sx={styles.listCard}>
      <Box sx={styles.listCardHeader}>
        <Typography sx={styles.listCardHeaderTitle}>{title}</Typography>
        <Box sx={styles.countBadge}>{count}</Box>
      </Box>
      <Box sx={styles.listCardBody}>{children}</Box>
    </Box>
  );
};
